import request from '../Functions/ajax/request'

export default async function PropertyDataLoader ({ params })
{
	return { page: getPage({ params }) };
}

async function getPage ({ params })
{
	try
	{
		var property = await request('/property/get')
		.config({ })
		.post({ slug: params.bien_reference });
	}
	catch (e)
	{
		throw { code: 404, throw_up: true, message: e?.error };
	}

	return { property };
}